import CommentButton from './CommentButton';
import CommentButtonContainer from './CommentButton.container';
export default CommentButtonContainer(CommentButton);
